
import React, { useState, useRef } from 'react'
import { CONTINENTS } from './continents'
import { COUNTRIES } from './countries'
import { PATHS } from './paths'

const World = (props) => {
const tooltipRef = useRef(null)
const [tooltipHeight, setHeight] = useState(0)
const [currentContinent, setCurrentContinent] = useState(false)
const [showTooltip, setShowTooltip] = useState(false)
const [tooltipPosition, setTooltipPosition] = useState(false)
const [lockPosition, setLockPosition] = useState(false)
const [mouseIn, setMouseIn] = useState(false)
const [currentProjects, setCurrentProjects] = useState(false)
const { projects } = props

const style = `<style>
path.hover { fill: url(#current-gradient); fill-opacity: 1; }
</style>`

const findContinent = (path) => {
  return CONTINENTS.find(({ country }) => country === path.className || country === path.name );
}

const findCountries = (continentName) => {
  return CONTINENTS.reduce((a, v) => { if (v.continent === continentName) { return [...a, v.country] } return a }, [] );
}

const findCountryCodes = (contries) => {
  return COUNTRIES.reduce((a, v) => { if (contries.includes(v.Name)) { return [...a, v.Code] } return a }, [] );
}

const findProjects = (countryCodes) => {
  return projects.reduce((a, v) => { if (countryCodes.includes(v.country_code)) { return [...a, v]} return a }, []);
}

const isInContinent = (path) => {
  return CONTINENTS.find(({ country, continent }) => (country === path.className || country === path.name) && continent === currentContinent) || false;
}
const handleMouseOver = (path, e) => {
  setMouseIn(true)
  const {continent} = findContinent(path)
  const cointries = findCountries(continent)
  const countryCodes = findCountryCodes(cointries)
  const projects = findProjects(countryCodes);
  if (projects.length) {
    setShowTooltip(true)
    setCurrentContinent(continent)
    setCurrentProjects(projects)
    setHeight(tooltipRef.current.offsetHeight)

    if (!lockPosition) {
      setTooltipPosition({x: e.clientX, y: e.clientY - tooltipHeight})
    }
  } else {
    setShowTooltip(false)
  }
}

const handleMouseOut = () => {
  setShowTooltip(false)
  setMouseIn(false)
}

const sortedAsc = (projects) => {
  return [...projects].sort((a, b) => {
    if (!a.slug) {
      return 1;
    }
  
    if (!b.slug) {
      return -1;
    }
  
    if (a.slug === b.slug) {
      return 0;
    }
  
    return a.slug < b.slug ? -1 : 1;
  });
}

const map = <svg 
    style={{width: "100%", height: "auto", display: "block"}}
    width="100%"
    baseProfile="tiny"
    fill="#262626"
    fillOpacity="0.25"
    stroke="white"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth=".8"
    version="1.2"
    viewBox="0 0 2000 857"
    xmlns="http://www.w3.org/2000/svg">
      {
        PATHS.map((path, key) =>  (
          <path
            key={key}
            onMouseOver={(e) => handleMouseOver(path, e)} className={`${isInContinent(path) && currentContinent && mouseIn ? 'hover' : ''} ${path.className || ''}`}
            d={path.d}
            id={path.id}
            name={path.name || ''}/>
        ))
      }
      
      <linearGradient id="current-gradient" x1="236" y1="172.5" x2="349" y2="172.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#220A67"/>
        <stop offset="1" stopColor="#3109A3"/>
      </linearGradient>
    </svg>

  const tooltip = <div ref={tooltipRef} onMouseLeave={() => setLockPosition(false)} onMouseOver={() => {setShowTooltip(true); setLockPosition(true)}} className={`map-tooltip ${showTooltip ? 'active' : ''} ${mouseIn ? '' : 'none'}  ${currentProjects.length !== 0 ? 'has-projects' : ''}`} style={{left: tooltipPosition.x, top: tooltipPosition.y}}>
    <div className="map-tooltip-inner-border">
      <div className="map-tooltip-inner">
        <h3 className="text-gradient text-gradient-dark">{currentContinent}</h3>
        <ul>
          { currentProjects &&
            sortedAsc(currentProjects).map((project) =>  {
              const name = project.name || project.slug;
              return (
                <li key={name} className="text-gradient text-gradient-dark">
                  { 
                    project.slug ? (
                      <a href={`/case-studies/${project.slug}`}>{name} <span className="arrow"/></a>
                    )
                    : (
                      name
                    )
                  }
                </li>
              )
            }
            )
          }
        </ul>
      </div>
    </div>
  </div>

  
  return (
    <div className="case-map" onMouseLeave={() => handleMouseOut() }>
      <div dangerouslySetInnerHTML={{__html:style}}></div>
      {map}
      {tooltip}
    </div>
  )
}
export default World